<script lang="ts">
	export let top = false;
	export let fill = "#62646a";

</script>

<svg
	class:top
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 27.633 14">
	<path
		d="M71.878 104.1a.616.616 0 0 1-.443-1.044l12.354-12.772-12.354-12.773a.616.616 0 0 1 .886-.856l12.768 13.2a.616.616 0 0 1 0 .856l-12.768 13.2a.617.617 0 0 1-.443.189z"
		transform="rotate(90 87.681 16.419)"
		style={`fill:${fill}`} />
</svg>

<style lang="scss">
	.top {
		transform: rotate(180deg);
	}

</style>
